import React from 'react'
import { useState } from 'react';
import { ChevronLeft } from '@material-ui/icons';

export default function ServerTableView({ data, setTerminationData, setFormData, genwizardAI }) {
    const [expandedRows, setExpandedRows] = useState(new Set());

    const toggleRow = (id) => {
        const newExpanded = new Set(expandedRows);
        if (newExpanded.has(id)) {
            newExpanded.delete(id);
        } else {
            newExpanded.add(id);
        }
        setExpandedRows(newExpanded);
    };
    const getStatusBadgeClass = (status) => {
        switch (status.toLowerCase()) {
            case 'running':
                return 'badge-running';
            case 'terminated':
            case 'terminating':
                return 'badge-terminated';
            case 'stopped':
            case 'stopping':
                return 'badge-stopped';
            default:
                return '';
        }
    };
    return (
        <>
            <tr
                className={expandedRows.has(data.caas_id) ? 'expanded' : ''}
                onClick={() => toggleRow(data.caas_id)}
                key={data.caas_id}
            >
                {/* {activeTab === 'dedicated' &&
                    (<td><span className="private-dns">{data.privateDNSName}</span></td>)
                } */}
                <td>{data.caas_productName}</td>
                <td>{data.caas_orderItemUid}</td>
                <td><span className="client-name">{data.caas_clientName}</span></td>
                <td><span className="badge badge-env">{data.caas_vendorName}</span></td>
                <td><span className="badge badge-env">{data.caas_environment}</span></td>
                <td>{data.caas_region}</td>
                <td>{data.caas_sed}</td>
                <td>
                    <span className={`badge ${getStatusBadgeClass(data.caas_state)}`}>
                        {data.caas_state}
                    </span>
                </td>
                <td>
                    <button className="action-btn"><ChevronLeft style={{ transform: !expandedRows.has(data.caas_id) ? 'rotate(-90deg)' : 'rotate(90deg)' }} /></button>
                </td>
            </tr>
            <tr className={`details-row ${!expandedRows.has(data.caas_id) ? 'hidden' : ''}`}>
                <td colSpan="10">
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ width: '98%', display: 'flex' }}>
                            <div style={{ width: '100%', border: '1px solid #BEBEBE', display: 'flex-inline', padding: '20px', textAlign: 'left', borderRadius: '8px 8px', backgroundColor: '#FFFFFF' }}>
                                <table className='innerserverdetails'>
                                    <tbody>
                                        <tr>
                                            <td>Access Link URL:</td>
                                            <td>
                                                {
                                                    data.caas_alinkURL != "" ?
                                                        <>
                                                            {
                                                                data.caas_alinkURL.split(",").map(item => {
                                                                    const subd = item.indexOf('iam-') >= 0 ? "/iam" : "";

                                                                    return (
                                                                        <>
                                                                            <a className='accessLink' href={'https://' + item + subd} target='_blank'>https://{item + subd}</a>
                                                                            <br />
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            Not Available
                                                        </>
                                                }</td>
                                            <td>Domain Context Root:</td>
                                            <td></td>
                                        </tr>
                                        {data.caas_productName === "Genwizard Agent" ?
                                            <>
                                                <tr>
                                                    <td>Product UID:</td>
                                                    <td>{data.caas_productUId}</td>
                                                    <td>App Core:</td>
                                                    <td>{data.caas_appcore}</td>
                                                </tr>
                                                <tr>
                                                    <td>Cluster ID:</td>
                                                    <td>{data.caas_dcr}</td>
                                                    <td>App Agent:</td>
                                                    <td>{data.caas_appagent}</td>
                                                </tr>
                                            </>
                                            :
                                            <>
                                                <tr>
                                                    <td>Product UID:</td>
                                                    <td>{data.caas_productUId}</td>
                                                    <td>Cluster ID:</td>
                                                    <td>{data.caas_dcr}</td>
                                                </tr>
                                            </>
                                        }
                                        <tr>
                                            <td>Customer Enterprise ID:</td>
                                            <td>{data.caas_customerEID}</td>
                                            <td>Secondary POC:</td>
                                            <td>{data.caas_secondaryPOC}</td>
                                        </tr>
                                        <tr>
                                            <td>Project Name:</td>
                                            <td>{data.caas_projectName}</td>
                                            <td>WBSE Code:</td>
                                            <td>{data.caas_wbsecode}</td>
                                        </tr>
                                        <tr>
                                            <td>Notes:</td>
                                            <td>{data.caas_notes}</td>
                                            <td>Date Started:</td>
                                            <td>{data.caas_dateInsert}</td>
                                        </tr>
                                        <tr>
                                            <td>AI Info:</td>
                                            <td>
                                                <button className='buttonActions' style={{ width: 'auto', margin: '0 3px', padding: '8px' }} disabled={data.caas_state !== 'running' ? true : false} onClick={() => genwizardAI(data.caas_contractID, data.caas_environment)}>GenAI OpenAI</button>
                                                {data.caas_appcore.includes('AM') &&
                                                    <button className='buttonActions' style={{ width: 'auto', margin: '0 3px', padding: '8px' }} disabled={data.caas_state !== 'running' ? true : false} onClick={() => genwizardAI(data.caas_contractID, data.caas_environment)}>GenAI Bedrock</button>
                                                }
                                            </td>
                                            <td>Action</td>
                                            <td>
                                                <button type="button" className='buttonActions'
                                                    style={{ width: 'auto', margin: '0 3px', padding: '8px' }}
                                                    onClick={() => setFormData(data)}>Edit Tags</button>
                                                <button type="button" className='buttonActions'
                                                    style={{ width: 'auto', margin: '0 3px', padding: '8px' }}
                                                    onClick={(e) => setTerminationData(data)}>Terminate</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </>
    )
}
